/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import html from './add-cell-dialog.module.html';
import css from './add-cell-dialog.module.css' with { type : 'css' };
import defsCSS from '../../definitions.module.css' with { type : 'css' };


/**
 * Add cell dialog
 */
export function showAddCellDialog(select : (cellType : string) => void) {

    const dialog = document.createElement('dialog') as HTMLDialogElement;
    const container = document.createElement('div');
    dialog.append(container);
    const root : ShadowRoot = container.attachShadow({ mode: 'open' });
    root.adoptedStyleSheets.push(defsCSS);
    root.adoptedStyleSheets.push(css);
    root.innerHTML = html;
    dialog.classList.add('add-cell-dialog');
    document.body.append(dialog);
    dialog.showModal();

    root.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', e => {
            const instrument = button.getAttribute('data-instrument') ?? 'piano';
            select(instrument);
            dialog.close();
            dialog.remove();
        })
    });

    dialog.addEventListener('click', (event) => {
        const r = dialog.getBoundingClientRect();
        const cx = event.clientX;
        const cy = event.clientY;
        if (cy < r.top || cy > r.bottom || cx < r.left || cx > r.right) {
            dialog.close();
            dialog.remove();
        }
    });
}
